// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__120CW"};